if (!customElements.get("clickable-badge")) {
  let listenersAttached = false;

  class ClickableBadge extends HTMLElement {
    constructor() {
      super();
      this.overlay = document.querySelector(".popup-overlay[badge-popup]");
      this.popup = document.querySelector(".badge-popup");
      this.closeBtn = document.querySelector(".badge-popup-close");
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.supportBtn = document.querySelector(".badge-popup-footer-button");
    }

    connectedCallback() {
      this.addEventListener("click", (e) => {
        this.handleTriggerClick();
      });
      if (this.overlay && !listenersAttached) {
        this.overlay.addEventListener("click", () => {
          this.handleCloseClick();
        });
      }

      if (this.supportBtn && !listenersAttached) {
        this.supportBtn.addEventListener("click", () => {
          this.handleCloseClick();
        });
      }

      if (this.closeBtn && !listenersAttached) {
        this.closeBtn.addEventListener("click", () => {
          this.handleCloseClick();
        });
      }
      listenersAttached = true;
    }

    disconnectedCallback() {
      this.removeEventListener("click", () => {
        this.handleTriggerClick();
      });
      if (this.overlay) {
        this.overlay.removeEventListener("click", () => {
          this.handleCloseClick();
        });
      }

      if (this.closeBtn) {
        this.closeBtn.removeEventListener("click", () => {
          this.handleCloseClick();
        });
      }

      if (this.supportBtn) {
        this.supportBtn.removeEventListener("click", () => {
          this.handleCloseClick();
        });
      }
    }

    handleTriggerClick() {
      this.changeSubheading();
      this.togglePopup();
    }

    handleCloseClick() {
      this.togglePopup();
    }

    togglePopup() {
      if (!this.popup || !this.overlay) return;

      this.overlay.classList.toggle("active");
      this.popup.classList.toggle("active");
      document.querySelector("body").classList.toggle("popup-active");
    }

    changeSubheading() {
      const subheading = document.querySelector(
        ".badge-popup-header-subtitle"
      );
      if (!subheading) return;

      if (this.dataset.type == "gallery") {
        subheading.textContent = "Why we are different";
      } else if (this.dataset.type == "buy_box") {
        subheading.textContent = "Why this price";
      }
    }
  }

  customElements.define("clickable-badge", ClickableBadge);
}
